/**
 * Hu Family Apps — the registry of apps this service hosts.
 *
 * Each app carries its own email allowlist. Sign-in is allowed for anyone on
 * at least one app's list; per-app access is enforced at the API layer and
 * the launcher only shows apps the signed-in user can open.
 */

export interface FamilyApp {
  id: string;
  name: string;
  tagline: string;
  href: string;
  emoji: string;
  allowedEmails: string[];
}

export const APPS: FamilyApp[] = [
  {
    id: "vacations",
    name: "Vacations",
    tagline: "Itineraries, bookings, and budgets",
    href: "/trip",
    emoji: "🧳",
    allowedEmails: [
      "jhh3000@gmail.com",
      "send2mavis@gmail.com",
      "mr1xiang@gmail.com",
    ],
  },
  {
    id: "finance",
    name: "Finances",
    tagline: "Net worth, spending, and projections",
    href: "/finance",
    emoji: "🌿",
    allowedEmails: ["jhh3000@gmail.com", "send2mavis@gmail.com"],
  },
];

/** Everyone allowed to sign in at all (union of the per-app lists). */
export const ALL_ALLOWED_EMAILS = [
  ...new Set(APPS.flatMap((app) => app.allowedEmails)),
];

export function appsForEmail(email: string | null | undefined): FamilyApp[] {
  if (!email) return [];
  return APPS.filter((app) => app.allowedEmails.includes(email));
}

export function canAccessApp(appId: string, email: string | null | undefined): boolean {
  if (!email) return false;
  const app = APPS.find((a) => a.id === appId);
  return !!app && app.allowedEmails.includes(email);
}
